import instance from "../utils/network";

export enum SubPrizeRewardLogType {
  REWARD = "REWARD", // 시상
  REWARD_CANCEL = "REWARD_CANCEL", // 시상 취소
}

export interface SubPrizeRewardLogAppResponse {
  pubName: string;
  type: SubPrizeRewardLogType;
  name: string;
  count: number;
  createdAt: Date;
}

export function getSubPrizeRewardLogList(
  pubId: number,
  year: number
): Promise<SubPrizeRewardLogAppResponse[]> {
  return instance.get(`nest/sub-prize/reward/log?pubId=${pubId}&year=${year}`);
}
